<template>
    <div>
        <div v-if="getActiveJourney">
            <here-info-bubble v-for="limit of limits" name="test-bubble" :key="limit.id" :lat="limit.latitude" :lng="limit.longitude" :component="speedInfoBubble" :data="{
                speed: calculateSpeed(limit.speed),
                heading: limit.heading,
                date: limit.date,
                hardwareId: limit.hardwareId,
                latitude: limit.latitude,
                longitude: limit.longitude,
                registrationNumber: limit.registrationNumber || 'Unknown',
                driverName: limit.driverName || 'Unknown',
                status: limit.status,
                hasStreamingDevice: deviceList.includes(limit.hardwareId),
                hasRequestVideoPermissions: hasAllRoles(['VideoRequests']) && checkMediaAccessibilityLicense(),
            }">
                <here-marker
                    :lat="limit.latitude"
                    :lng="limit.longitude"
                    :icon="{
                    bitmap: invisibleIcon,
                    size: { w: 35, h: 35 },
                    options: { anchor: { x:15, y: 0 } },
                    hitArea: hitArea
            }">
                </here-marker>
            </here-info-bubble>

            <here-info-bubble v-for="event in getActiveJourney.events" name="event-bubble" :key="event.id" :lat="event.locations[0].lat" :lng="event.locations[0].lng" :component="eventInfoBubble" :data="{
                event: event,
                eventTypes: getEventTypes
            }">
                <here-marker
                    v-if="event.isVisible"
                    :key="event.id"
                    :lat="event.locations[0].lat"
                    :lng="event.locations[0].lng"
                    :icon="{
                        bitmap: iconsEvent
                    }"
                    :map="map"
                ></here-marker>
            </here-info-bubble>
            <div v-if="startAndStopPoints.length" class="start-and-stop-wrapper">
                <here-marker
                    v-for="point in startAndStopPoints"
                    :key="point.utcTimestamp"
                    :lat="point.location.lat"
                    :lng="point.location.lng"
                    :icon="{
                        bitmap: point.type === 'start' ? iconsStart : iconsEnd
                    }"
                    :map="map"
                ></here-marker>
            </div>
            <here-polyline :points="dataLines" with-arrows></here-polyline>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import { calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import HereInfoBubble from '@/components/maps/here/components/HereInfoBubble'
import HereMarker from '@/components/maps/here/components/HereMarker'
import SpeedInfoBubble from '@/components/atoms/SpeedInfoBubble'
import EventInfoBubble from '@/components/atoms/EventInfoBubble'
import HerePolyline from '@/components/maps/here/components/HerePolyline'
import DeviceApi from '@/api/DeviceApi'

const deviceApi = new DeviceApi()

export default {
    name: 'HereDrawJourneys',
    components: { HerePolyline, HereMarker, HereInfoBubble },
    inject: ['map', 'platform', 'group'],
    data () {
        return {
            invisibleIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521" opacity="0.00"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#aed51b"/><g transform="translate(6.079 11.699)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
            iconsEvent: '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#fe2e58"/><g transform="translate(6.079 12.761)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
            iconsStart: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42"><g transform="translate(-618 -1269)"><path d="M13.458,39.193C2.107,22.737,0,21.048,0,15a15,15,0,0,1,30,0c0,6.048-2.107,7.737-13.458,24.193a1.876,1.876,0,0,1-3.083,0Z" transform="translate(619 1270)" fill="#aed522" stroke="#000" stroke-width="2"/><text transform="translate(629 1276)" stroke="#000" stroke-width="1" font-size="17" font-family="HelveticaNeue, Helvetica Neue"><tspan x="0" y="16">S</tspan></text></g></svg>',
            iconsEnd: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40"><g transform="translate(-619 -1270)"><path d="M13.458,39.193C2.107,22.737,0,21.048,0,15a15,15,0,1,1,30,0c0,6.048-2.107,7.737-13.458,24.193a1.876,1.876,0,0,1-3.083,0Z" transform="translate(619 1270)" fill="#db1238"/></g><circle cx="11" cy="11" r="11" transform="translate(4 4)" fill="#fff"/><g transform="translate(6.56 6.959)"><g transform="translate(1.8)"><path d="M15.77.8H3.318V.266A.287.287,0,0,0,3.015,0H2.1a.287.287,0,0,0-.3.266V16.215a.287.287,0,0,0,.3.266h.911a.287.287,0,0,0,.3-.266V9.835H15.77a.287.287,0,0,0,.3-.266V1.063A.287.287,0,0,0,15.77.8ZM2.711,15.949h-.3V.532h.3ZM15.466,3.987H12.429V6.645h3.037V9.3H12.429V6.645H9.392V9.3H6.355V6.645H3.318V3.987H6.355V1.329H9.392V3.987h3.037V1.329h3.037Z" transform="translate(-1.8)" fill="#db1238"/><rect width="2.4" height="2.4" transform="translate(4.814 4.062)" fill="#db1238"/></g></g></svg>',
            limits: [],
            dataLines: [],
            deviceList: [],
            hitArea: null,
            startAndStopPoints: [],
            speedInfoBubble: SpeedInfoBubble,
            eventInfoBubble: EventInfoBubble
        }
    },
    computed: {
        ...mapGetters({
            getActiveJourney: 'trackingModule/getActiveJourney',
            getVehicleJourney: 'trackingModule/getVehicleJourney',
            getEventTypes: 'dictionaryModule/getEventTypes'
        })
    },
    watch: {
        getActiveJourney (value) {
            if (null == this.map() || null == this.group()) return

            this.clearSubscriptionVehicles()

            this.drawStartAndStop()

            this.drawJourneyOnHereMap()
            this.drawLimitPoints()
        }
    },
    mounted () {
        this.getDevicesWithStreaming()
    },
    methods: {
        ...mapActions({
            'clearSubscriptionVehicles': 'trackingModule/clearSubscriptionVehicles'
        }),
        async getDevicesWithStreaming () {
            const response = await deviceApi.getDevicesWithStreamingAbility()
            if (!response.isSuccess) {
                return
            }

            this.deviceList = response.payload
        },
        calculateSpeed (speed) {
            return calculateSpeedOrDistanceUnit(speed);
        },
        drawJourneyOnHereMap () {
            if (null == this.getActiveJourney || null == this.getActiveJourney.extendedRoute) {
                return
            }

            this.dataLines = []

            let filtered = []

            if (0 < this.getActiveJourney.rootObject.tracePoints.length) {
                if (1000 > this.getActiveJourney.rootObject.tracePoints.length) {
                    filtered = this.getActiveJourney.rootObject.tracePoints
                } else {
                    filtered = this.getActiveJourney.rootObject.tracePoints.filter((item, index) => {
                        return 0 === index % 5
                    })
                }

                filtered.forEach((point) => {
                    // eslint-disable-next-line no-undef
                    this.dataLines.push(new H.geo.Point(point.lat, point.lon))
                })
            } else {
                if (1000 > this.getActiveJourney.extendedRoute.length) {
                    filtered = this.getActiveJourney.extendedRoute
                } else {
                    filtered = this.getActiveJourney.extendedRoute.filter((item, index) => {
                        return 0 === index % 5
                    })
                }

                filtered.forEach((journey) => {
                    // eslint-disable-next-line no-undef
                    this.dataLines.push(new H.geo.Point(journey.lat, journey.lng))
                })
            }

            setTimeout(() => {
                this.map().getViewModel().setLookAtData({
                    bounds: this.group().getBoundingBox()
                })
            }, 10)
        },
        drawLimitPoints () {
            if (null == this.getActiveJourney || null == this.getActiveJourney.extendedRoute) {
                return
            }

            this.limits = []

            // eslint-disable-next-line no-undef
            this.hitArea = new H.map.HitArea(H.map.HitArea.ShapeType.CIRCLE, [1, 1, 1])

            if (0 < this.getActiveJourney.rootObject.tracePoints.length) {
                this.getActiveJourney.rootObject.tracePoints.forEach((item) => {
                    if (null != item.lat && null != item.lon) {
                        this.limits.push({
                            status: item.status || 'unknown',
                            registrationNumber: this.getVehicleJourney.registrationNumber || 'Unknown',
                            driverName: this.getVehicleJourney.driverName,
                            latitude: item.lat,
                            longitude: item.lon,
                            speedLimit: Math.round(item.speedLimit || 0),
                            speed: Math.round(item.speedInKph || 0),
                            heading: item.headingMatched || 0,
                            date: item.utc,
                            hardwareId: this.getActiveJourney.hardwareId
                        })
                    }
                })
            } else {
                this.getActiveJourney.extendedRoute.forEach((item) => {
                    if (null != item.lat && null != item.lng) {
                        this.limits.push({
                            status: item.status || 'unknown',
                            registrationNumber: this.getVehicleJourney.registrationNumber || 'Unknown',
                            driverName: this.getVehicleJourney.driverName,
                            latitude: item.lat,
                            longitude: item.lng,
                            speedLimit: Math.round(item.speedLimit || 0),
                            speed: Math.round(item.speedInKph || 0),
                            heading: item.headingMatched || 0,
                            date: item.utc,
                            hardwareId: this.getActiveJourney.hardwareId
                        })
                    }
                })
            }
        },
        drawStartAndStop () {
            const startPoint = this.getActiveJourney.startPoint
            const endPoint = this.getActiveJourney.endPoint
            startPoint.type = 'start'
            endPoint.type = 'stop'

            this.startAndStopPoints = [startPoint, endPoint]
        },
        drawEvents () {

        }
    },
    render () {
        return null
    }
}
</script>
